import { TEt3DivRef } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const ET3DivRef = withLiteObserverAndTheme<TEt3DivRef>((props) => {
  const {
    children,
    width,
    height,
    fDirection,
    color,
    style,
    theme,
    alignItems,
    justifyContent,
    withShadow,
    isScrollable,
    isExtendable,
    onClick,
    refDiv
  } = props;
  const { unitX, unitY, shadow } = theme;
  let divStyleInit = isExtendable ? {} : { height: height * unitY };

  const className = isScrollable ? "scroll-container" : "";
  let divStyle = {
    ...divStyleInit,
    display: "flex",
    flexDirection: fDirection,
    alignItems: alignItems,
    justifyContent: justifyContent,
    minHeight: height * unitY,
    minWidth: width * unitX,
    width: width * unitX,
    backgroundColor: color,
    ...style
  };
  if (withShadow) {
    divStyle = { ...divStyle, ...shadow };
  }
  return (
    <div className={className} style={divStyle} onClick={onClick} ref={refDiv}>
      {children}
    </div>
  );
});
export default ET3DivRef;
